/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_TitleInputs */

const en_clients_title = /** @type {(inputs: Clients_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

const pt_br2_clients_title = /** @type {(inputs: Clients_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clientes`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Clients_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_title = /** @type {((inputs?: Clients_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_title(inputs)
	return pt_br2_clients_title(inputs)
});